import { BooleanEditor } from './BooleanEditor'
import { IconPickerEditor } from './IconPickerEditor'
import { MultiSelectEditor } from './MultiSelectEditor'
import { NumberEditor } from './NumberEditor'
import { registerEditComponent } from './registry'
import type { EditorComponent } from './registry'
import { SelectEditor } from './SelectEditor'
import { TextEditor } from './TextEditor'

let registered = false

export const registerBuiltInEditors = (): void => {
	if (registered) {
		return
	}
	registerEditComponent('text', TextEditor as unknown as EditorComponent)
	registerEditComponent('number', NumberEditor as unknown as EditorComponent)
	registerEditComponent('select', SelectEditor as EditorComponent)
	registerEditComponent('multiSelect', MultiSelectEditor as EditorComponent)
	registerEditComponent('boolean', BooleanEditor as unknown as EditorComponent)
	registerEditComponent('icon-picker', IconPickerEditor)
	registered = true
}
